import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogBodyProps } from './DialogBody.types';

const DeleteDialogBody = ({ name }: DialogBodyProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Fragment>
      {t('accessFunction.deletePopup.message', { name })}
      <br />
      {t('accessFunction.deletePopup.description')}
    </Fragment>
  );
};

export default DeleteDialogBody;
